export const environment = {
    sylvesterApiUrl: 'https://felix.telephony-dev.nelnet.info/api'
}

export const AuthConfig = {
    pingClientID: 'FelixDev',
    pingLoginURL: 'https://sso.nelnet.com',
    pingWellKnownEndpointsURL: 'https://sso.nelnet.com/.well-known/openid-configuration',
    pingRedirectUri: 'https://felix.telephony-dev.nelnet.info',
    pingEndSessionUri: 'https://felix.telephony-dev.nelnet.info',
    JWTUserIDField: 'UPN'
}
